import React, { useEffect, useState } from 'react'
import MyButton from '../../UI/form/MyButton'
import WorkLinePlaceGroupForm from './form/WorkLinePlaceGroupForm'
import MySpiner from '../../UI/spiner/MySpiner'
import { getWorkLinePlaceGroupAPI } from '../../../api/workLinePlaceGroup/workLinePlaceGroupAPI'
import { responseError } from '../../../helpers/response/ResponseHelper'
import ErrorMessage from '../../UI/messages/ErrorMessage'
import { getDepartmentIdFromDepartmentObj, getDepartmentTypeFromDepartmentObj } from '../../../helpers/department/DepartmentHelper'
import WorkLinePlaceUserList from './WorkLinePlaceUserList'

const WorkLinePlaceGroup = ({ workLinePlace, department }) => {

	// console.log('department', department)

	const [workLinePlaceGroup, setWorkLinePlaceGroup] = useState(null)
	const [open, setOpen] = useState(false)
	const [error, setError] = useState('')
	const [loading, setLoading] = useState(false)

	// console.log('workLinePlaceGroup', workLinePlaceGroup)

	useEffect(() => {
		getUsersGroup()
	}, [])

	const getUsersGroup = () => {
		setLoading(true)
		getWorkLinePlaceGroupAPI({ workLinePlaceId: workLinePlace.id }).then(data => {
			setWorkLinePlaceGroup(data)
			setLoading(false)
		}).catch(e => {
			setError(responseError(e))
			setLoading(false)
		})
	}

  return (
    <div>
        <br />
        <br />
        <p className='packResultBlock__text'>
			{
				workLinePlaceGroup ?
					'Люди, що працюють з Вами в групі'
				:
					'З Вами працює група людей? Додайте всіх перед початком роботи'
			}
		</p>
        
		{
			loading ?
				<MySpiner />
			:
			error ?
				<ErrorMessage error={error} />
			:
			workLinePlaceGroup ?
				<WorkLinePlaceUserList
					users={workLinePlaceGroup.users}
					// deleteUser={deleteUser}
					// isCanDelete={true}
				/>
			:
				!open ?
					<MyButton
						onClick={e => setOpen(true)}
					>
						Додати людей в групу
					</MyButton>
				: 
					<WorkLinePlaceGroupForm 
						departmentType={getDepartmentTypeFromDepartmentObj({ department })}
						departmentId={getDepartmentIdFromDepartmentObj({ department })}
						workLinePlaceId={workLinePlace.id}
					/>
		}

    </div>
  )
}

export default WorkLinePlaceGroup